import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function UCatPage() {

  return (
    <ProjectLayout
      title="uCat"
      role="Unity Developer (C#) - VR (Quest 3)"
      team="3"
      duration="1 Year"
      engine="Unity (C#) - VR, Meta Voice SDK"
    //   about="uCat is a Brain-Computer Interface VR startup that aims to help paralyzed users regain their function and autonomy through the metaverse."
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/uCat.mp4`}
      playLink={`https://www.ucat.app/`}
      playText={"uCat Website"}
      galleryImages = {[
    `${process.env.PUBLIC_URL}/img/ucat/1.png`,
    `${process.env.PUBLIC_URL}/img/ucat/2.png`,
    `${process.env.PUBLIC_URL}/img/ucat/3.png`,
  ]}
    >
      <section>
        <h2>About</h2>
        <p>
            uCat is a Brain-Computer Interface VR startup that aims to help paralyzed users regain their function and autonomy through the metaverse.
        </p>
      </section>

      <section>
        <h2>What I Learned</h2>
        <p>
         I worked on uCat's VR prototype from 2022-2024 as the lead developer. Through this process I learned how to work with cross-functional teams, which was challenging given our vastly different timezones.
         The prototype served as a showcase of the potential of Brain-Computer Interface integration with a VR application, and was very fulfilling to develop. I learned how to optimize programs for Quest headsets,
         how to create a completely voice-controlled UX using the Meta Voice SDK, and working with designing for paralyzed patients.
        </p>
      </section>

    
    </ProjectLayout>
  );
}
